<div
  class="balance-benefit-cell"
  [class.balance-benefit-cell--disabled]="disabled"
  data-balance-benefit-cell
  [satPopoverAnchor]="popover"
  (click)="onOpen(popover)">
  <span class="balance-benefit-cell__label">{{ label }}:</span>

  <ng-container *ngIf="modified; else maybeAmbiguous">
    <mat-icon
      class="balance-benefit-cell__warning-icon"
      color="warn"
      [matTooltip]="'balance.benefits.modified' | translate"
      matTooltipPosition="above"
      (click)="$event.stopPropagation()">warning</mat-icon>
  </ng-container>
  <ng-template #maybeAmbiguous>
    <mat-icon
      *ngIf="ambiguous"
      class="balance-benefit-cell__warning-icon"
      color="warn"
      [matTooltip]="'balance.benefits.ambiguous' | translate"
      matTooltipPosition="above"
      (click)="$event.stopPropagation()">warning</mat-icon>
  </ng-template>

  <span class="balance-benefit-cell__value" data-balance-benefit-cell-value>
    <ng-container *ngIf="!isNone; else noneLabel">
      <ng-container [ngSwitch]="format">
        <ng-container *ngSwitchCase="'percent'">{{ displayValue }}%</ng-container>
        <ng-container *ngSwitchDefault>{{ displayValue | currency:'USD' }}</ng-container>
      </ng-container>
    </ng-container>
    <ng-template #noneLabel>{{ 'balance.benefits.none' | translate }}</ng-template>
  </span>

  <mat-icon *ngIf="!disabled" class="balance-benefit-cell__edit-icon">edit</mat-icon>

  <mat-icon
    *ngIf="modified && !disabled"
    class="balance-benefit-cell__reset-icon"
    data-balance-benefit-cell-reset
    [matTooltip]="'balance.benefits.reset' | translate"
    matTooltipPosition="above"
    (click)="reset(); $event.stopPropagation()">refresh</mat-icon>
</div>

<sat-popover #popover hasBackdrop (closed)="onClosed()">
  <mat-card class="balance-benefit-cell__popover">
    <mat-card-content>
      <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <mat-label>{{ 'balance.benefits.amount-label' | translate }}</mat-label>
        <input
          matInput
          type="number"
          min="0"
          [max]="format === 'percent' ? 100 : null"
          [disabled]="supportsNone && draft == null"
          [ngModel]="draft"
          (ngModelChange)="onDraftChange($event)"
          (keyup)="onPopoverKeyup($event, popover)"
          data-balance-benefit-cell-input />
      </mat-form-field>

      <mat-checkbox
        *ngIf="supportsNone"
        [checked]="draft == null"
        (change)="onNoneChange($event)"
        data-balance-benefit-cell-none>
        {{ 'balance.benefits.none' | translate }}
      </mat-checkbox>
    </mat-card-content>
  </mat-card>
</sat-popover>
